import React from 'react';
import './QuestionNav.scss';
import QuestionNumberContainer from "../../remote/screen/questionnumber/QuestionNumberContainer";
import QuestionNavButtonsContainer from "./buttons/QuestionNavButtonsContainer";

const QuestionNav = props => {
  return (
    <div className="QuestionNav">
      <div className="CurrentQuestion">
        Question <QuestionNumberContainer/>
      </div>
      <QuestionNavButtonsContainer/>
    </div>
  );
};

export default QuestionNav;
